import React, { useState, useEffect, createRef } from 'react';
import { Helmet } from "react-helmet";
import { Redirect, Link, useLocation, useRouteMatch } from 'react-router-dom';
import withSizes from 'react-sizes';

import auth from '../services/auth';
import fetcher from '../services/fetcher'
import log from '../services/log'
import seo from '../services/seo'

import Layout from '../pages/_Layout';
import SignInButton from '../components/SignInButton';
import JoinReferralButton from '../components/buttons/JoinReferralButton';
import Uvp from '../components/Uvp';
import AlertsList from '../components/AlertsList';
import Heatmap from '../components/Heatmap';
import MouseScroll from '../components/MouseScroll'
import Footer from '../components/Footer';
import CoinChip from '../components/CoinChip';
import CoinCard from '../components/CoinCard';
import GooglePlayButton from '../components/buttons/GooglePlayButton';
import AppStoreButton from '../components/buttons/AppStoreButton';
import LandingCta from '../components/landing/LandingCta';
import MovingAlertsList from '../components/MovingAlertsList';

import useIndicators from '../hooks/useIndicators';


import '../css/landing.css'

function RSI(props){
  const coinFromUrl = useRouteMatch({ path: "/relative-strength-index/:coin",  strict: true });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const nameFromQuery = queryParams.get('name');

  const [indicators, isIndicatorsLoading] = useIndicators()
  const [coins, setCoins] = useState(null)
  const [alerts, setAlerts] = useState(null)
  const [alertsHistory, setAlertsHistory] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedCoin, setSelectedCoin] = useState({
    coin: coinFromUrl.params.coin.toUpperCase(),
    name: nameFromQuery ? decodeURIComponent(nameFromQuery) : coinFromUrl.params.coin.toUpperCase(),
    _loaded: false
  })
  const _ref = createRef();

  async function getCoins(){
    setIsLoading(true)
    const rsiData = await fetcher.getRSI()
    //log.traceTag('rsi', rsiData)
    if (rsiData){
        setIsLoading(false)
        setCoins(rsiData.filter(x => x.rsi != null))
    }
  }

  async function getAlerts(){
    setIsLoading(true)
    const latestAlerts = await fetcher.getSignals()
    log.traceTag('alerts', alerts)
    if (latestAlerts && coins){
        setIsLoading(false)
        const filteredAlerts = latestAlerts.filter(a => coins.map(c => c.coin).includes(a.coin))
        log.traceTag('filteredAlerts', filteredAlerts);
        setAlerts(filteredAlerts)
        //log.trace(alerts);
    }
  }

  async function getAlertsHistory(){
    setIsLoading(true)
    const alertsHistory = await fetcher.getAlertsHistory(selectedCoin.coin)
    log.traceTag('alerts', alerts)
    if (alertsHistory && coins){
        setIsLoading(false)
        setAlertsHistory(alertsHistory)
    }
  }

  useEffect(() => {
    if (selectedCoin){
      getAlertsHistory()
      refreshWidget()
    }
  }, [selectedCoin]);

  useEffect(() => {
    if (coins){
      getAlerts();
      const matchedCoin = coins.find(c => c.coin === coinFromUrl.params.coin.toUpperCase());
      if (matchedCoin){
        setSelectedCoin({
          ...matchedCoin,
          name: nameFromQuery ? decodeURIComponent(nameFromQuery) : matchedCoin.name
        });
      }
    }
  }, [coins]);

  useEffect(() => {
      getCoins()
  }, []);

  console.log(process.env.NODE_ENV)

  const refreshWidget = () => {
    if (!_ref.current) return;
    _ref.current.innerHTML = "";
    log.trace('refreshWidget')

    const tvdDiv = document.createElement('div');
    tvdDiv.setAttribute('style', 'height: 600px')
    tvdDiv.innerHTML = `<div id="tradingview_266d5" style="height: 600px"></div>`;
    _ref.current.appendChild(tvdDiv);

    const tvScript = document.createElement('script');
    tvScript.innerHTML = `new TradingView.widget({
    "symbol": "BINANCE:${selectedCoin.coin}USDT",
    "interval": "4H",
    "timezone": "Etc/UTC",
    "theme": "light",
    "style": "1",
    "locale": "en",
    "toolbar_bg": "#f1f3f6",
    "enable_publishing": false,
    "allow_symbol_change": true,
    "container_id": "tradingview_266d5",
    "autosize" : true,
    "studies":[
        "RSI@tv-basicstudies"
    ]
    });`;

    _ref.current.appendChild(tvScript);
}

  return (
    <Layout>
    <div className="container">
      {selectedCoin &&
      <>
        {seo.coinRSI(selectedCoin)}
        <Uvp 
          showScreenshots={false} 
          coin={selectedCoin}
          coins={coins}
          alerts={alerts ? alerts.slice(0, 10) : null}
        >
        </Uvp>
        <section className="py-10 md:py-14">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              <span className="hl-silver">
              {selectedCoin.coin} ({selectedCoin.name})</span> RSI Live, Price, Moves, Alerts & Charts
              </h2>
             <p className={`mt-3 mb-6 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`} style={{lineHeight: 1.7+'em'}}>
              CryptoWaves.app scans crypto market in real time and sends you {selectedCoin.coin} ({selectedCoin.name}) RSI notifications straight to your Email, Telegram & Mobile so you never miss the best time to buy or sell {selectedCoin.coin} ({selectedCoin.name}) again.
              </p>
            {coins && selectedCoin._loaded != false &&
              <>
                <CoinCard coin={selectedCoin}></CoinCard>
                <div className="mt-5 mb-3">
                  <div className="tradingview-widget-container" ref={_ref}>
                  </div>
                </div>
              </>
            }
          </div>
        </section>

        <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Get <span style={{fontWeight: 300}}>RSI Alerts</span> On Your Email <span className="hide-small">& Telegram</span>
            </>
          )}
        />

        <MouseScroll></MouseScroll>

         <section className="py-10 md:py-14">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
             <h2 className="my-3 text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              Track <span className="hl-silver">{selectedCoin.coin} ({selectedCoin.name})</span>  RSI In Real-Time
              </h2>
            <p className={`mt-3 mb-6 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`} style={{lineHeight: 1.7+'em'}}>
              Watch {selectedCoin.coin} ({selectedCoin.name}) and other 150 coins price moves using unique RSI Crypto Market Heatmap. Immediately spot the next big opportunity to deploy cold cash or fix great profit.
              </p>
            {indicators && coins && alerts && !isLoading &&
              <Heatmap showToggle={false} indicators={indicators} landing={true} coins={coins} portfolio={[]} alerts={alerts} filters={
                {
                  sort: {
                    rank: [1,0],
                    _1h: [0,0],
                    _24h: [0,0],
                    _7d: [0,0],
                    _30d: [0, 0],
                    rsi: [0,0],
                    rsi_1d: [0,0],
                  },
                  view: {
                    list: false,
                    heatmap: true,
                    alerts: false
                  },
                  search: selectedCoin.coin
                }
              } onCoinSelected={(coinSymbol) => {
                window.location.href=`/relative-strength-index/${seo.toSlug(coinSymbol)}`
              }}></Heatmap>
            }
          </div>
        </section>

        <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Get <span style={{fontWeight: 300}}>RSI Alerts</span> On Your Email <span className="hide-small">& Telegram</span>
            </>
          )}
        />

        <section className="py-12 md:py-16">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              Real-Time <span className="hl-silver">RSI Alerts</span> For 150 Crypto Coins
            </h2>
            <p className={`m-3 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`} style={{lineHeight: 1.7+'em'}}>
              CryptoWaves.app scans crypto market in real time and sends you personalized crypto RSI signals straight to your Email, Telegram & Mobile so you never miss the crypto price dips and spikes even for altcoins you do not yet track.
            </p>
            {coins && alerts && !isLoading &&
              <MovingAlertsList
                landing={true}
                coins={coins}
                alerts={alerts.slice(0, 10)}
                visibleCount={3}
                itemHeight={120}
                durationMs={24000}
                onCoinSelected={(coinSymbol) => {
                }}
              ></MovingAlertsList>
            }
          </div>
        </section>

        <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Get <span style={{fontWeight: 300}}>RSI Alerts</span> On Your Email <span className="hide-small">& Telegram</span>
            </>
          )}
        />

        <MouseScroll></MouseScroll>

         <section className="py-10 md:py-14">
          <div className="rsi mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
             <h2 className="my-3 text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              What is {selectedCoin.coin} ({selectedCoin.name}) RSI Strategy?
            </h2>

            <p className={`mt-3 mb-6 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`} style={{lineHeight: 1.7+'em'}}>
           
              RSI or “relative strength index” is used by traders and investors to find profitable {selectedCoin.name} entry and exit prices.
              </p><br/>
            <div className="text-muted text-left">
              <p>
              {selectedCoin.name} RSI is a very simple yet powerful indicator to find best time to entry or exit {selectedCoin.name} trade on a mid-term or long-term interval. {selectedCoin.name} RSI oscillates between 0 and 100. The most common RSI reading is that a particular crypto asset is "overbought" when the RSI line crosses the 70 level and an "oversold" when the RSI line crosses 30. That interpretation is based on the idea that if the {selectedCoin.name} has been oversold (or overbought) it's therefore has a high probability of rebounding. Some traders use different range pairs like 80/20 (that is pretty common to see on crypto market) for more strong price signal identification and avoiding false RSI alerts. Truth be told it is very rare that the market can maintain it’s current momentum by the time the RSI indicator is signalling above 80 or below 20. 

              </p><br/>
              <p>
              During trends, the {selectedCoin.name} RSI readings may fall into a band or range. During an uptrend on a crypto market, the {selectedCoin.name} RSI tends to stay above 30 and will frequently hit 70. During a downtrend, it is rare to see the {selectedCoin.name} RSI exceed 70, and the indicator frequently hits 30 or below. Traders and investors must be aware that on a bull market, RSI for most crypto coins often jumps between 40 and 90 (for example DOGE and ETC were both way over 80 during the last crypto market top), with levels 40 and 50 acting as a support range. For a bear market, traders can see RSI most often belongs the range from 20 to 60, with levels 55 and 60 acting as the hightest price ceiling.
              </p><br/>
              <p>
              CryptoWaves.app helps traders and investors track {selectedCoin.name} relative strength index (RSI) indicator in real time, receive {selectedCoin.name} price alerts and RSI signal notifications straight on their email.
              </p>
            </div>

          </div>
        </section>

       <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Get <span style={{fontWeight: 300}}>RSI Alerts</span> On Your Email <span className="hide-small">& Telegram</span>
            </>
          )}
        />

        <MouseScroll></MouseScroll>

        <section className="py-12 md:py-16">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              Crypto Relative Strength Index Alerts, <span className="hl-silver">History & Charts</span>
            </h2>
            <h3 className={`my-3 text-base 5 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`}  style={{lineHeight: 1.7+'em'}}>
              CryptoWaves.app keep, track and process RSI alerts & signals for more than 150 coins in real-time and  help you to get buy/sell recommendation based on recent price moves and volumes so you can capture more return on your investment.
            </h3>
            {coins && alerts && !isLoading &&
              <>
                {coins.slice(0, 50).map(coin => <CoinChip key={coin.coin} coin={coin} onClick={(symbol) => {
                  window.location.href=`/relative-strength-index/${seo.toSlug(symbol)}`
                }}></CoinChip>)}
              </>
            }
            <Link className="text-sm text-gray-500 hover:text-gray-700">And more...</Link>
          </div>
        </section>

        <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Get Crypto <span style={{fontWeight: 300}}> Market </span> Insight
            </>
          )}
        />

        <Footer></Footer>
      </>
      }
      </div>
      </Layout>
  );
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(RSI);
